import { useTranslation } from 'react-i18next';
import { SavedViewPicker } from '../savedViews/SavedViewPicker';
import { useSelectSavedView } from '../savedViews/useSelectSavedView';
import { AdvancedButton } from './AdvancedButton';
import { FilterChip } from './FilterChip';
import type { IFilterRowProps } from './IFilterRowProps';
import { QuickFilterSelect } from './QuickFilterSelect';
import { ViewTabs } from './ViewTabs';
import './filters.css';

/**
 * Рядок фільтрів сторінки модуля (UIUX patterns/filtering, прототип v4): ліворуч — вкладки подань, чип активного пункту меню, чип швидкого
 * фільтра й чипи умов розширених фільтрів; праворуч (переноситься й притискається праворуч) — «Фільтр [Усі записи · N ▾]», «Розширені
 * фільтри», роздільник, збережене подання з кнопками «Редагувати подання» й «Нове подання». Лічильники «Фільтр» — у множині моделі
 * (model.domain: сторінка-список, як розділ «Проєктування»), на сторінках модуля (`wholeType`) — по всьому типу, як у прототипі.
 */
export function FilterRow({ model, table, item, advanced, chips, views, wholeType }: IFilterRowProps) {
  const { t } = useTranslation();
  const selectView = useSelectSavedView(model);
  const quick = model.state.quickFilter;
  return (
    <div className="lv-filters">
      {table && <ViewTabs rt={model.rt} module={model.module} active={model.state.view} onChange={model.openView} />}
      {item && <FilterChip outlined label={item.label} clearLabel={t('listbar.clearFilter')} onClear={item.onClear} />}
      {quick !== 'all' && <FilterChip label={t(`listbar.quick.${quick}`)} clearLabel={t('listbar.clearFilter')} onClear={() => model.setState({ quickFilter: 'all' })} />}
      {chips}
      <div className="lv-filters__right">
        <span className="lv-filters__label">{t('listbar.filter')}</span>
        <QuickFilterSelect ws={model.ws} rt={model.rt} domain={wholeType ? undefined : model.domain} value={quick} onChange={(q) => model.setState({ quickFilter: q })} />
        <AdvancedButton count={advanced.count} open={advanced.open} onToggle={advanced.onToggle} />
        {table && views && (
          <>
            <span className="lv-filters__sep" aria-hidden="true" />
            <SavedViewPicker ws={model.ws} rt={model.rt.key} value={model.state.savedViewId} onChange={selectView} onEdit={views.onEdit} onNew={views.onNew} />
          </>
        )}
      </div>
    </div>
  );
}
